export default {
    name: 'Digital',
    prefix: 'digital', // css class prefix
    rootStyle: 'digitalRoot',
    componentStyles: {
        AccordionCard: {
            accordionToggle: 'digitalAccordionToggle'
        },
        Button: {
            button: 'digitalButton',
            secondary: 'digitalSecondary'
        },
        Checkbox: {
            checkbox: 'digitalCheckbox',
            checkboxIcon: 'digitalCheckboxIcon',
            checkboxElement: 'digitalCheckboxElement',
            checkboxElementWrapper: 'digitalCheckboxElementWrapper',
            input: 'digitalCheckboxInput'
        },
        CurrencyField: {
            currency: 'digitalCurrency'
        },
        DatePickerField: {
            datePicker: 'digitalDatePicker'
        },
        DropdownSelect: {
            valueContainer: 'digitalValueContainer',
            control: 'digitalControl'
        },
        InlineNotification: {
            inlineNotification: 'digitalInlineNotification',
            iconWrapper: 'digitalInlineNotificationIconWrapper'
        },
        Toggle: {
            toggle: 'digitalToggle',
            toggleButton: 'digitalToggleButton',
            active: 'digitalToggleActive'
        },
        FieldComponent: {
            fieldComponent: 'digitalFieldComponent',
            left: 'digitalFieldComponentAliginLeft',
            reversed: 'digitalReversed',
            contentContainer: 'digitalContentContainer',
            fullWidth: 'digitalFullWidth',
            controlReadOnly: 'digitalControlReadOnly'
        },
        FieldLabel: {
            fieldLabelContainer: 'digitalFieldLabelContainer',
            fieldLabel: 'digitalFieldLabel',
            primaryLabel: 'digitalPrimaryLabel',
            left: 'digitalLeft'
        },
        FileUpload: {
            wrapper: 'digitalFileUploadWrapper',
            valueText: 'digitalFileUploadValueText'
        },
        GenericSelectControl: {
            genericSelect: 'digitalGenericSelect',
        },
        Link: {
            link: 'digitalLink'
        },
        Stepper: {
            stepper: 'digitalStepper',
            button: 'digitalStepperButton'
        },
        Table: {
            table: 'digitalTable',
            row: 'digitalRow'
        },
        TypeaheadMultiSelect: {
            control: 'digitalControl',
            menu: 'digitalTypeaheadMenu'
        },
        Header: {
            header: 'headerContent'
        }
    },
};
